const PIXIE_DAILY_HINT_KEY = 'mhome-pixie-daily-hint-seen';
const PIXIE_DAILY_QUERY = 'pixieDaily';

function pixieDailyRouteOpen(query) {
  return String((query && query[PIXIE_DAILY_QUERY]) || '') === '1';
}

function pixieDailyReturnLocation(query) {
  return {
    path: '/mhome',
    query: { ...(query || {}), [PIXIE_DAILY_QUERY]: '1' },
  };
}

function pixieDailyAllowed(role) {
  if (role == null || role === "") return false;
  const n = Number(role);
  return Number.isFinite(n) && n < 3;
}

function pixieDailyHintSeen(storage) {
  try {
    return storage.getItem(PIXIE_DAILY_HINT_KEY) === '1';
  } catch {
    return true;
  }
}

function markPixieDailyHintSeen(storage) {
  try {
    storage.setItem(PIXIE_DAILY_HINT_KEY, '1');
  } catch {
    /* storage can be unavailable */
  }
}

/**
 * `right` for the hint callout so a 40px arrow, aligned to the callout's
 * right edge, centers on the pixie daily icon. Distances are from the page's
 * right edge. The icon is absolutely positioned inside the padded title bar.
 */
function pixieDailyHintArrowRight({
  welcomePadding = 10,
  iconRight = 72,
  iconPadding = 12,
  iconSize = 22,
  arrowWidth = 40,
} = {}) {
  const iconWidth = iconSize + iconPadding * 2;
  const centerFromRight = welcomePadding + iconRight + iconWidth / 2;
  return Math.round(centerFromRight - arrowWidth / 2);
}

module.exports = {
  PIXIE_DAILY_HINT_KEY,
  PIXIE_DAILY_QUERY,
  pixieDailyRouteOpen,
  pixieDailyReturnLocation,
  pixieDailyAllowed,
  pixieDailyHintSeen,
  markPixieDailyHintSeen,
  pixieDailyHintArrowRight,
};
